export default __webpack_public_path__ + "static/fonts/Anko-Regular.b6417e7.woff2";